/**
 * Capture feature — command palette contribution.
 *
 * One scope + two commands:
 *   "Open Capture"  — navigates to the capture grid
 *   "Start stream"  — opens a new stream parent note and activates it
 *                     in the composer (next Enter binds to it)
 */
import { GridNine, List } from "@phosphor-icons/react";

import type {
  Command,
  FeaturePalette,
  ScopeNode,
} from "@/shared/components/command-palette/types";

import { startStream } from "./api";
import { useActiveStreamStore } from "./stores/active-stream-store";

const CAPTURE_SCOPE: ScopeNode = {
  id: "capture",
  parentId: null,
  title: "Capture",
  icon: GridNine,
  href: "/capture",
  keywords: ["grid", "agent", "note", "stream", "capture", "input", "blip"],
};

const OPEN_GRID: Command = {
  id: "capture.open-grid",
  title: "Open Capture",
  subtitle: "The unified input surface — fire blips, see cards, end streams",
  icon: GridNine,
  scopeId: "capture",
  keywords: ["grid", "capture", "open", "agents"],
  run: (ctx) => ctx.router.push("/capture"),
};

const START_STREAM: Command = {
  id: "capture.start-stream",
  title: "Start stream",
  subtitle: "Open a new bulleted-note stream; next Enter appends to it",
  icon: List,
  scopeId: "capture",
  keywords: ["stream", "bullet", "new note", "start"],
  run: async (ctx) => {
    try {
      const note = await startStream(null);
      useActiveStreamStore.getState().activate({
        streamId: note.id,
        title: note.title,
        startedAt: note.started_at,
      });
      ctx.router.push("/capture");
    } catch (err) {
      console.error("[capture] start-stream failed:", err);
    }
  },
};

export const capturePalette: FeaturePalette = {
  scopes: [CAPTURE_SCOPE],
  commands: [OPEN_GRID, START_STREAM],
};
